import React from 'react';
import classlist from 'utils/classlist';
import StepItem from './Item';
import './style.scss';

interface StepsProps {
    steps?: Array<{
        node?: React.ReactNode;
        title: React.ReactNode;
    }>;
    step?: number;
    className?: string;
    activeNode?: React.ReactNode;
    children?: React.ReactNode;
}

const Steps: React.FC<StepsProps> = ({ steps, step, className, activeNode }) => {
    return (
        <div className={classlist('comp-steps-root', className)}>
            {steps!.map((item, index) => {
                const isActive = step === index + 1;
                const isComplete = (step || 0) >= index + 1;

                return (
                    <StepItem
                        key={index}
                        activeNode={activeNode}
                        index={index}
                        step={index}
                        isComplete={isComplete}
                        isActive={isActive}
                        node={item.node}>
                        <div className="item-content">{item.title}</div>
                    </StepItem>
                );
            })}
        </div>
    );
};

export default Steps;
